/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseListReferentialTagConversation } from '../models/api-response-list-referential-tag-conversation';
import { ApiResponsePagedResultReferentialTagConversation } from '../models/api-response-paged-result-referential-tag-conversation';
import { ApiResponseReferentialTagConversation } from '../models/api-response-referential-tag-conversation';
import { createReferentialTagConversation } from '../fn/referential-tag-conversation-api/create-referential-tag-conversation';
import { CreateReferentialTagConversation$Params } from '../fn/referential-tag-conversation-api/create-referential-tag-conversation';
import { deleteReferentialTagConversation } from '../fn/referential-tag-conversation-api/delete-referential-tag-conversation';
import { DeleteReferentialTagConversation$Params } from '../fn/referential-tag-conversation-api/delete-referential-tag-conversation';
import { getReferentialTagConversationByRef } from '../fn/referential-tag-conversation-api/get-referential-tag-conversation-by-ref';
import { GetReferentialTagConversationByRef$Params } from '../fn/referential-tag-conversation-api/get-referential-tag-conversation-by-ref';
import { listReferentialTagConversation } from '../fn/referential-tag-conversation-api/list-referential-tag-conversation';
import { ListReferentialTagConversation$Params } from '../fn/referential-tag-conversation-api/list-referential-tag-conversation';
import { patchArchiveStatus1 } from '../fn/referential-tag-conversation-api/patch-archive-status-1';
import { PatchArchiveStatus1$Params } from '../fn/referential-tag-conversation-api/patch-archive-status-1';
import { searchReferentialTagConversation } from '../fn/referential-tag-conversation-api/search-referential-tag-conversation';
import { SearchReferentialTagConversation$Params } from '../fn/referential-tag-conversation-api/search-referential-tag-conversation';
import { updateReferentialTagConversation } from '../fn/referential-tag-conversation-api/update-referential-tag-conversation';
import { UpdateReferentialTagConversation$Params } from '../fn/referential-tag-conversation-api/update-referential-tag-conversation';

@Injectable({ providedIn: 'root' })
export class ReferentialTagConversationApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getReferentialTagConversationByRef()` */
  static readonly GetReferentialTagConversationByRefPath = '/v1/api/ui/referential/tag/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getReferentialTagConversationByRef()` instead.
   *
   * This method doesn't expect any request body.
   */
  getReferentialTagConversationByRef$Response(params: GetReferentialTagConversationByRef$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseReferentialTagConversation>> {
    return getReferentialTagConversationByRef(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getReferentialTagConversationByRef$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getReferentialTagConversationByRef(params: GetReferentialTagConversationByRef$Params, context?: HttpContext): Observable<ApiResponseReferentialTagConversation> {
    return this.getReferentialTagConversationByRef$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseReferentialTagConversation>): ApiResponseReferentialTagConversation => r.body)
    );
  }

  /** Path part for operation `updateReferentialTagConversation()` */
  static readonly UpdateReferentialTagConversationPath = '/v1/api/ui/referential/tag/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateReferentialTagConversation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateReferentialTagConversation$Response(params: UpdateReferentialTagConversation$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseReferentialTagConversation>> {
    return updateReferentialTagConversation(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateReferentialTagConversation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateReferentialTagConversation(params: UpdateReferentialTagConversation$Params, context?: HttpContext): Observable<ApiResponseReferentialTagConversation> {
    return this.updateReferentialTagConversation$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseReferentialTagConversation>): ApiResponseReferentialTagConversation => r.body)
    );
  }

  /** Path part for operation `deleteReferentialTagConversation()` */
  static readonly DeleteReferentialTagConversationPath = '/v1/api/ui/referential/tag/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteReferentialTagConversation()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteReferentialTagConversation$Response(params: DeleteReferentialTagConversation$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteReferentialTagConversation(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteReferentialTagConversation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteReferentialTagConversation(params: DeleteReferentialTagConversation$Params, context?: HttpContext): Observable<void> {
    return this.deleteReferentialTagConversation$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createReferentialTagConversation()` */
  static readonly CreateReferentialTagConversationPath = '/v1/api/ui/referential/tag';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createReferentialTagConversation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createReferentialTagConversation$Response(params: CreateReferentialTagConversation$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseReferentialTagConversation>> {
    return createReferentialTagConversation(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createReferentialTagConversation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createReferentialTagConversation(params: CreateReferentialTagConversation$Params, context?: HttpContext): Observable<ApiResponseReferentialTagConversation> {
    return this.createReferentialTagConversation$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseReferentialTagConversation>): ApiResponseReferentialTagConversation => r.body)
    );
  }

  /** Path part for operation `searchReferentialTagConversation()` */
  static readonly SearchReferentialTagConversationPath = '/v1/api/ui/referential/tag/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchReferentialTagConversation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchReferentialTagConversation$Response(params: SearchReferentialTagConversation$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultReferentialTagConversation>> {
    return searchReferentialTagConversation(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchReferentialTagConversation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchReferentialTagConversation(params: SearchReferentialTagConversation$Params, context?: HttpContext): Observable<ApiResponsePagedResultReferentialTagConversation> {
    return this.searchReferentialTagConversation$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultReferentialTagConversation>): ApiResponsePagedResultReferentialTagConversation => r.body)
    );
  }

  /** Path part for operation `patchArchiveStatus1()` */
  static readonly PatchArchiveStatus1Path = '/v1/api/ui/referential/tag/archive/{ref}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchArchiveStatus1()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchArchiveStatus1$Response(params: PatchArchiveStatus1$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return patchArchiveStatus1(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchArchiveStatus1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchArchiveStatus1(params: PatchArchiveStatus1$Params, context?: HttpContext): Observable<void> {
    return this.patchArchiveStatus1$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listReferentialTagConversation()` */
  static readonly ListReferentialTagConversationPath = '/v1/api/ui/referential/tag/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listReferentialTagConversation()` instead.
   *
   * This method doesn't expect any request body.
   */
  listReferentialTagConversation$Response(params: ListReferentialTagConversation$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListReferentialTagConversation>> {
    return listReferentialTagConversation(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listReferentialTagConversation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listReferentialTagConversation(params: ListReferentialTagConversation$Params, context?: HttpContext): Observable<ApiResponseListReferentialTagConversation> {
    return this.listReferentialTagConversation$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListReferentialTagConversation>): ApiResponseListReferentialTagConversation => r.body)
    );
  }

}
